// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.contact-section,
.site-footer {
	box-sizing: border-box;
	max-width: 1040px;
	margin: 0 auto;
	padding-left: 36px;
	padding-right: 36px;
	color: #332e2b;
	font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
}

.contact-section {
	position: relative;
	padding-top: 68px;
	padding-bottom: 116px;
}

.section-label {
	position: absolute;
	top: 74px;
	right: 36px;
	color: #6b8fc3;
	font-size: 13px;
	letter-spacing: 1.5px;
	text-transform: uppercase;
}

.contact-heading h2 {
	margin: 0;
	font-size: clamp(38px, 5vw, 52px);
	font-weight: 400;
	letter-spacing: -1.5px;
	line-height: 1;
}

.contact-rule,
.footer-rule {
	height: 1px;
	background: #4a4542;
}

.contact-rule {
	margin-top: 17px;
}

.contact-copy {
	width: 38%;
	padding-top: 39px;
	color: #989492;
	font-size: 14px;
	line-height: 1.55;
}

.contact-intro {
	margin: 0 0 28px;
	color: #414756;
	font-size: 14px;
	line-height: 1.55;
}

.contact-intro a {
	color: #6b8fc3;
	text-decoration: none;
}

.contact-body {
	display: block;
	padding: 0 36px;
}

.contact-copy p {
	margin: 0 0 18px;
}

#contact .section-title h2::before {
	display: none;
	content: none;
}

.contact-icon {
	display: none;
}

.contact-envelope {
	display: block;
	font-size: 56px;
	line-height: 1;
}

.contact-envelope::before {
	content: "\\f0e0";
}

.contact-email,
.footer-email {
	color: #4b4643;
	font-weight: 600;
	text-decoration: none;
}

.footer-email:hover,
.footer-email:focus {
	color: #b9a7dc;
}

.contact-form {
	width: 61%;
	margin: -106px 0 0 auto;
}

.contact-form label {
	display: block;
	margin-bottom: 14px;
	color: #6b8fc3;
	font-size: 11px;
	letter-spacing: 1.3px;
	text-transform: uppercase;
}

.contact-field-row {
	display: grid;
	grid-template-columns: 1fr 1fr;
	gap: 14px;
}

.contact-form input,
.contact-form textarea {
	box-sizing: border-box;
	display: block;
	width: 100%;
	margin-top: 6px;
	border: 1px solid #dedbd9;
	border-radius: 4px;
	padding: 13px 15px;
	color: #332e2b;
	background: #fff;
	font: inherit;
	font-size: 14px;
	outline: none;
}

.contact-form input {
	height: 43px;
}

.contact-form textarea {
	min-height: 117px;
	resize: vertical;
}

.contact-form input:focus,
.contact-form textarea:focus {
	border-color: #6b8fc3;
}

.contact-form input::placeholder,
.contact-form textarea::placeholder {
	color: #c3bfbd;
}

.contact-form button {
	margin-top: 1px;
	border: 1px solid #6b8fc3;
	border-radius: 0;
	padding: 11px 22px;
	color: #5d5855;
	background: #fff;
	font: inherit;
	font-size: 13px;
	font-weight: 600;
	cursor: pointer;
}

.contact-form button:hover:not(:disabled) {
	color: #fff;
	background: #6b8fc3;
}

.contact-form button:disabled {
	cursor: wait;
	opacity: .6;
}

.form-status {
	margin: 12px 0 0;
	color: #6b8fc3;
	font-size: 13px;
}

.form-status-error {
	color: #a45757;
}

.site-footer {
	padding-bottom: 23px;
}

.site-footer .footer-rule {
	width: calc(100% + 72px);
	margin-left: -36px;
}

.footer-content {
	position: relative;
	min-height: 174px;
	padding-top: 29px;
}

.footer-statement {
	max-width: 700px;
	font-size: clamp(30px, 3.2vw, 38px);
	font-weight: 400;
	letter-spacing: -0.5px;
	line-height: 1.2;
}

.footer-line {
	display: block;
	white-space: nowrap;
}

.footer-accent {
	color: #5f83b9;
}

.footer-meta {
	position: absolute;
	right: 0;
	bottom: 26px;
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	gap: 13px;
	font-size: 13px;
}

.footer-links {
	display: flex;
	align-items: center;
	justify-content: center;
	width: 100%;
	gap: 20px;
}

.footer-links a {
	color: #4b4643;
	text-decoration: none;
}

.footer-links a:hover,
.footer-links a:focus {
	color: #b9a7dc;
}

.footer-links li {
	list-style: none;
}

.footer-links li a {
	font-size: 0;
}

.footer-links li a::after {
	font-size: 13px;
}

.footer-links li:nth-child(1) a::after { content: "LinkedIn"; }
.footer-links li:nth-child(2) a::after { content: "GitHub"; }

.footer-copyright {
	position: absolute;
	bottom: 0;
	left: 50%;
	color: #aaa5a2;
	font-size: 10px;
	letter-spacing: 2px;
	text-transform: uppercase;
	transform: translateX(-50%);
	white-space: nowrap;
}

.portfolio-page {
	width: min(1040px, calc(100% - 60px));
}

.section-title h2 {
	font-size: 30px;
}

.resume-section .section-title h2,
#education.section-title h2,
#contact .section-title h2 {
	font-size: 30px;
}

#resume .section-title h2 {
	font-size: 30px;
}

.site-header {
	position: sticky;
	top: 0;
	z-index: 100;
	background: #fff;
	box-shadow: 0 1px 0 rgba(63, 57, 52, .12);
}

.nav-links a.active {
	color: #6b8fc3;
	font-weight: 600;
}

.back-to-top {
	position: fixed;
	right: 24px;
	bottom: 24px;
	display: grid;
	place-items: center;
	width: 40px;
	height: 40px;
	border: 1px solid #6b8fc3;
	border-radius: 50%;
	color: #6b8fc3;
	background: #fff;
	box-shadow: 0 2px 8px rgba(63, 57, 52, .12);
	font-size: 14px;
	text-decoration: none;
}

.back-to-top:hover,
.back-to-top:focus {
	color: #fff;
	background: #6b8fc3;
}

#about,
#resume,
#education,
#contact {
	scroll-margin-top: 84px;
}

.brand span {
	display: inline-grid;
	place-items: center;
	width: 30px;
	height: 30px;
	border-radius: 5px;
	margin-right: 9px;
	padding: 0;
	font-size: 13px;
	line-height: 1;
	text-align: center;
	vertical-align: middle;
}

.resume-link {
	padding-top: 5px;
	padding-bottom: 5px;
}

.site-header a.resume-link:hover,
.site-header a.resume-link:focus,
.site-header a.resume-link:active {
	border-color: #6b8fc3;
	color: #fff !important;
	background: #6b8fc3;
}

.skill-group span {
	padding-top: 2px;
	padding-bottom: 2px;
}

.education-strip {
	display: block;
	width: 100%;
	border-top: 0;
}

.education-item {
	width: 100%;
}

.monogram {
	display: block;
	width: 100%;
	height: auto;
	object-fit: cover;
}

.hero-section {
	align-items: center;
}

.profile-summary {
	align-self: center;
	margin-top: 0;
}

.summary-meta strong {
	font-size: 11px;
}

@media (min-width: 721px) {
	.resume-section .section-title h2,
	#education.section-title h2,
	#contact .section-title h2 {
		font-size: 30px;
	}

	#resume h3 {
		font-size: 25px;
	}
}

#contact.contact-section {
	display: block;
	width: 100%;
	max-width: none;
	padding: 0 0 116px;
	border-top: 0;
	color: #332e2b;
}

#contact .section-title {
	display: flex;
	justify-content: space-between;
	align-items: baseline;
	margin: 0 0 20px;
	padding-bottom: 10px;
	border-bottom: 1px solid #3f3934;
}

#contact .section-title h2 {
	color: #332e2b;
	letter-spacing: 1px;
}

#contact .section-title span {
	color: #6b8fc3;
	font-size: 10px;
	letter-spacing: 1.5px;
	text-transform: uppercase;
}

#contact .contact-heading h2 {
	margin: 0;
	color: #332e2b;
	font-size: clamp(38px, 5vw, 52px);
	font-weight: 400;
	letter-spacing: -1.5px;
	line-height: 1;
	text-transform: none;
}

#contact .contact-copy {
	display: block;
	width: 100%;
	margin: 0;
	padding-top: 0;
}

#contact .contact-icon {
	padding-top: 0;
}

#contact .contact-intro {
	margin: 0 0 28px;
	color: #414756;
	font-size: 14px;
	line-height: 1.55;
}

#contact .contact-body {
	display: block;
	padding: 0 60px;
}

#contact .contact-copy p {
	margin: 0 0 18px;
	color: #414756;
	font-size: 14px;
	line-height: 1.55;
}

#contact .contact-copy a {
	color: #6b8fc3;
	text-decoration: none;
}

#contact a,
#contact a:visited {
	color: #525252;
	font-weight: 600;
}

#contact a:focus,
#contact a:hover {
	color: #b9a7dc;
}

#contact .contact-form {
	display: block;
	width: 100%;
	margin: 0;
}

#contact .contact-form label {
	display: block;
	width: auto;
	margin: 0 0 14px;
	float: none;
	color: #6b8fc3;
	font: 11px/1.2 "Helvetica Neue", Helvetica, Arial, sans-serif;
	font-weight: 400;
	letter-spacing: 1.3px;
	text-transform: uppercase;
}

#contact .contact-field-row {
	display: grid;
	grid-template-columns: 1fr 1fr;
	gap: 14px;
}

#contact .contact-form input,
#contact .contact-form textarea {
	box-sizing: border-box;
	display: block;
	width: 100%;
	min-width: 0;
	max-width: none;
	margin: 6px 0 0;
	border: 1px solid #dedbd9;
	border-radius: 4px;
	padding: 13px 15px;
	color: #332e2b;
	background: #fff;
	font: 14px/1.45 "Helvetica Neue", Helvetica, Arial, sans-serif;
	outline: none;
}

#contact .contact-form input {
	height: 43px;
}

#contact .contact-form textarea {
	min-height: 117px;
	resize: vertical;
}

#contact .contact-form button {
	display: inline-block;
	margin: 1px 0 0;
	border: 1px solid #6b8fc3;
	border-radius: 4px;
	padding: 11px 22px;
	color: #5d5855;
	background: #fff;
	font: 600 13px/1.2 "Helvetica Neue", Helvetica, Arial, sans-serif;
	letter-spacing: 0;
	text-transform: none;
}

#contact .contact-form button:hover:not(:disabled) {
	color: #fff;
	background: #6b8fc3;
}

@media (max-width: 800px) {
	.education-strip {
		grid-template-columns: 1fr;
		gap: 25px;
	}

	.site-footer {
		padding-left: 22px;
		padding-right: 22px;
	}

	.site-footer .footer-rule {
		width: calc(100% + 44px);
		margin-left: -22px;
	}

	.footer-content {
		min-height: 238px;
	}

	.footer-statement {
		max-width: none;
		font-size: 24px;
		line-height: 1.25;
	}

	.footer-line {
		white-space: normal;
	}

	.footer-meta {
		position: static;
		align-items: center;
		margin-top: 28px;
		font-size: 14px;
	}

	.footer-links {
		width: auto;
		gap: 20px;
	}

	.footer-copyright {
		bottom: 0;
	}
}

@media (min-width: 721px) and (max-width: 800px) {
	.skill-grid {
		grid-template-columns: repeat(2, 1fr);
		gap: 24px;
		margin: 45px 0 60px;
	}
}

@media (max-width: 500px) {
	.portfolio-page {
		width: calc(100% - 76px);
	}
}

@media (max-width: 720px) {
	.portfolio-page {
		width: calc(100% - 32px);
	}

	#contact.contact-section {
		padding: 0 0 80px;
	}

	#contact .contact-copy,
	#contact .contact-form {
		width: 100%;
	}

	#contact .contact-form {
		margin: 0;
	}

	#contact .contact-body {
		padding: 0 30px;
	}

	#contact .contact-form {
		margin-top: 42px;
	}

	#contact .contact-field-row {
		grid-template-columns: 1fr;
		gap: 0;
	}

	.hero-section {
		align-items: start;
	}

	.section-title h2 {
		font-size: 25px;
	}

	.resume-section .section-title h2,
	#education.section-title h2,
	#contact .section-title h2 {
		font-size: 25px;
	}

	#resume .section-title h2 {
		font-size: 25px;
	}

	#resume h3 {
		font-size: 20px;
	}

	.contact-section,
	.site-footer {
		padding-left: 22px;
		padding-right: 22px;
	}

	.site-footer .footer-rule {
		width: calc(100% + 44px);
		margin-left: -22px;
	}

	.section-label {
		right: 22px;
	}

	.contact-copy,
	.contact-form {
		width: 100%;
	}

	.contact-form {
		margin-top: 42px;
	}

	.contact-field-row {
		grid-template-columns: 1fr;
		gap: 0;
	}

	.footer-content {
		min-height: 238px;
	}

	.footer-statement {
		max-width: none;
		font-size: 24px;
		line-height: 1.25;
	}

	.footer-line {
		white-space: normal;
	}

	.footer-meta {
		position: static;
		align-items: center;
		margin-top: 28px;
		font-size: 14px;
	}

	.footer-links {
		width: auto;
		gap: 20px;
	}

	.footer-copyright {
		bottom: 0;
	}

	.skill-grid {
		grid-template-columns: 1fr;
		gap: 0;
		margin: 42px 0 58px;
	}

	.skill-group {
		border-top: 2px solid #3f3934;
		padding: 17px 0 24px;
	}

	.skill-group h3 {
		margin-bottom: 14px;
		color: #866aa0;
		font-size: 14px;
		letter-spacing: 1.5px;
	}

	.skill-group span {
		margin: 0 5px 8px 0;
		padding: 8px 14px;
		border: 1px solid #b7c7e5;
		border-radius: 16px;
		color: #525252;
		font-size: 14px;
	}

	.profile-summary {
		display: block;
		width: 100%;
		margin-top: 24px;
	}

	.profile-summary .monogram {
		width: 100%;
		aspect-ratio: 0.8;
		border-radius: 4px;
		object-fit: cover;
	}

	.profile-summary .summary-meta {
		display: flex;
		justify-content: space-between;
		align-items: center;
		gap: 16px;
		margin-top: 20px;
		padding-top: 17px;
		border-top: 1px solid #3f3934;
		font-size: 14px;
	}
}

@media (min-width: 501px) and (max-width: 720px) {
	.profile-summary {
		padding: 0 12px;
	}

	.profile-summary .monogram,
	.profile-summary .summary-meta {
		width: 60%;
		margin-left: auto;
		margin-right: auto;
	}
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;;CAEC,sBAAsB;CACtB,iBAAiB;CACjB,cAAc;CACd,kBAAkB;CAClB,mBAAmB;CACnB,cAAc;CACd,2DAA2D;AAC5D;;AAEA;CACC,kBAAkB;CAClB,iBAAiB;CACjB,qBAAqB;AACtB;;AAEA;CACC,kBAAkB;CAClB,SAAS;CACT,WAAW;CACX,cAAc;CACd,eAAe;CACf,qBAAqB;CACrB,yBAAyB;AAC1B;;AAEA;CACC,SAAS;CACT,iCAAiC;CACjC,gBAAgB;CAChB,sBAAsB;CACtB,cAAc;AACf;;AAEA;;CAEC,WAAW;CACX,mBAAmB;AACpB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,UAAU;CACV,iBAAiB;CACjB,cAAc;CACd,eAAe;CACf,iBAAiB;AAClB;;AAEA;CACC,gBAAgB;CAChB,cAAc;CACd,eAAe;CACf,iBAAiB;AAClB;;AAEA;CACC,cAAc;CACd,qBAAqB;AACtB;;AAEA;CACC,cAAc;CACd,eAAe;AAChB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,aAAa;CACb,aAAa;AACd;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,cAAc;CACd,eAAe;CACf,cAAc;AACf;;AAEA;CACC,gBAAgB;AACjB;;AAEA;;CAEC,cAAc;CACd,gBAAgB;CAChB,qBAAqB;AACtB;;AAEA;;CAEC,cAAc;AACf;;AAEA;CACC,UAAU;CACV,uBAAuB;AACxB;;AAEA;CACC,cAAc;CACd,mBAAmB;CACnB,cAAc;CACd,eAAe;CACf,qBAAqB;CACrB,yBAAyB;AAC1B;;AAEA;CACC,aAAa;CACb,8BAA8B;CAC9B,SAAS;AACV;;AAEA;;CAEC,sBAAsB;CACtB,cAAc;CACd,WAAW;CACX,eAAe;CACf,yBAAyB;CACzB,kBAAkB;CAClB,kBAAkB;CAClB,cAAc;CACd,gBAAgB;CAChB,aAAa;CACb,eAAe;CACf,aAAa;AACd;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,iBAAiB;CACjB,gBAAgB;AACjB;;AAEA;;CAEC,qBAAqB;AACtB;;AAEA;;CAEC,cAAc;AACf;;AAEA;CACC,eAAe;CACf,yBAAyB;CACzB,gBAAgB;CAChB,kBAAkB;CAClB,cAAc;CACd,gBAAgB;CAChB,aAAa;CACb,eAAe;CACf,gBAAgB;CAChB,eAAe;AAChB;;AAEA;CACC,WAAW;CACX,mBAAmB;AACpB;;AAEA;CACC,YAAY;CACZ,WAAW;AACZ;;AAEA;CACC,gBAAgB;CAChB,cAAc;CACd,eAAe;AAChB;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,oBAAoB;AACrB;;AAEA;CACC,wBAAwB;CACxB,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,iBAAiB;CACjB,iBAAiB;AAClB;;AAEA;CACC,gBAAgB;CAChB,mCAAmC;CACnC,gBAAgB;CAChB,sBAAsB;CACtB,gBAAgB;AACjB;;AAEA;CACC,cAAc;CACd,mBAAmB;AACpB;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,kBAAkB;CAClB,QAAQ;CACR,YAAY;CACZ,aAAa;CACb,sBAAsB;CACtB,uBAAuB;CACvB,SAAS;CACT,eAAe;AAChB;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,uBAAuB;CACvB,WAAW;CACX,SAAS;AACV;;AAEA;CACC,cAAc;CACd,qBAAqB;AACtB;;AAEA;;CAEC,cAAc;AACf;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,eAAe;AAChB;;AAEA,yCAAyC,mBAAmB,EAAE;AAC9D,yCAAyC,iBAAiB,EAAE;;AAE5D;CACC,kBAAkB;CAClB,SAAS;CACT,SAAS;CACT,cAAc;CACd,eAAe;CACf,mBAAmB;CACnB,yBAAyB;CACzB,2BAA2B;CAC3B,mBAAmB;AACpB;;AAEA;CACC,qCAAqC;AACtC;;AAEA;CACC,eAAe;AAChB;;AAEA;;;CAGC,eAAe;AAChB;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,gBAAgB;CAChB,MAAM;CACN,YAAY;CACZ,gBAAgB;CAChB,yCAAyC;AAC1C;;AAEA;CACC,cAAc;CACd,gBAAgB;AACjB;;AAEA;CACC,eAAe;CACf,WAAW;CACX,YAAY;CACZ,aAAa;CACb,mBAAmB;CACnB,WAAW;CACX,YAAY;CACZ,yBAAyB;CACzB,kBAAkB;CAClB,cAAc;CACd,gBAAgB;CAChB,2CAA2C;CAC3C,eAAe;CACf,qBAAqB;AACtB;;AAEA;;CAEC,WAAW;CACX,mBAAmB;AACpB;;AAEA;;;;CAIC,uBAAuB;AACxB;;AAEA;CACC,oBAAoB;CACpB,mBAAmB;CACnB,WAAW;CACX,YAAY;CACZ,kBAAkB;CAClB,iBAAiB;CACjB,UAAU;CACV,eAAe;CACf,cAAc;CACd,kBAAkB;CAClB,sBAAsB;AACvB;;AAEA;CACC,gBAAgB;CAChB,mBAAmB;AACpB;;AAEA;;;CAGC,qBAAqB;CACrB,sBAAsB;CACtB,mBAAmB;AACpB;;AAEA;CACC,gBAAgB;CAChB,mBAAmB;AACpB;;AAEA;CACC,cAAc;CACd,WAAW;CACX,aAAa;AACd;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,cAAc;CACd,WAAW;CACX,YAAY;CACZ,iBAAiB;AAClB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,kBAAkB;CAClB,aAAa;AACd;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC;;;EAGC,eAAe;CAChB;;CAEA;EACC,eAAe;CAChB;AACD;;AAEA;CACC,cAAc;CACd,WAAW;CACX,eAAe;CACf,kBAAkB;CAClB,aAAa;CACb,cAAc;AACf;;AAEA;CACC,aAAa;CACb,8BAA8B;CAC9B,qBAAqB;CACrB,gBAAgB;CAChB,oBAAoB;CACpB,gCAAgC;AACjC;;AAEA;CACC,cAAc;CACd,mBAAmB;AACpB;;AAEA;CACC,cAAc;CACd,eAAe;CACf,qBAAqB;CACrB,yBAAyB;AAC1B;;AAEA;CACC,SAAS;CACT,cAAc;CACd,iCAAiC;CACjC,gBAAgB;CAChB,sBAAsB;CACtB,cAAc;CACd,oBAAoB;AACrB;;AAEA;CACC,cAAc;CACd,WAAW;CACX,SAAS;CACT,cAAc;AACf;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,gBAAgB;CAChB,cAAc;CACd,eAAe;CACf,iBAAiB;AAClB;;AAEA;CACC,cAAc;CACd,eAAe;AAChB;;AAEA;CACC,gBAAgB;CAChB,cAAc;CACd,eAAe;CACf,iBAAiB;AAClB;;AAEA;CACC,cAAc;CACd,qBAAqB;AACtB;;AAEA;;CAEC,cAAc;CACd,gBAAgB;AACjB;;AAEA;;CAEC,cAAc;AACf;;AAEA;CACC,cAAc;CACd,WAAW;CACX,SAAS;AACV;;AAEA;CACC,cAAc;CACd,WAAW;CACX,gBAAgB;CAChB,WAAW;CACX,cAAc;CACd,6DAA6D;CAC7D,gBAAgB;CAChB,qBAAqB;CACrB,yBAAyB;AAC1B;;AAEA;CACC,aAAa;CACb,8BAA8B;CAC9B,SAAS;AACV;;AAEA;;CAEC,sBAAsB;CACtB,cAAc;CACd,WAAW;CACX,YAAY;CACZ,eAAe;CACf,eAAe;CACf,yBAAyB;CACzB,kBAAkB;CAClB,kBAAkB;CAClB,cAAc;CACd,gBAAgB;CAChB,8DAA8D;CAC9D,aAAa;AACd;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,iBAAiB;CACjB,gBAAgB;AACjB;;AAEA;CACC,qBAAqB;CACrB,eAAe;CACf,yBAAyB;CACzB,kBAAkB;CAClB,kBAAkB;CAClB,cAAc;CACd,gBAAgB;CAChB,iEAAiE;CACjE,iBAAiB;CACjB,oBAAoB;AACrB;;AAEA;CACC,WAAW;CACX,mBAAmB;AACpB;;AAEA;CACC;EACC,0BAA0B;EAC1B,SAAS;CACV;;CAEA;EACC,kBAAkB;EAClB,mBAAmB;CACpB;;CAEA;EACC,wBAAwB;EACxB,kBAAkB;CACnB;;CAEA;EACC,iBAAiB;CAClB;;CAEA;EACC,eAAe;EACf,eAAe;EACf,iBAAiB;CAClB;;CAEA;EACC,mBAAmB;CACpB;;CAEA;EACC,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;CAChB;;CAEA;EACC,WAAW;EACX,SAAS;CACV;;CAEA;EACC,SAAS;CACV;AACD;;AAEA;CACC;EACC,qCAAqC;EACrC,SAAS;EACT,mBAAmB;CACpB;AACD;;AAEA;CACC;EACC,wBAAwB;CACzB;AACD;;AAEA;CACC;EACC,wBAAwB;CACzB;;CAEA;EACC,iBAAiB;CAClB;;CAEA;;EAEC,WAAW;CACZ;;CAEA;EACC,SAAS;CACV;;CAEA;EACC,eAAe;CAChB;;CAEA;EACC,gBAAgB;CACjB;;CAEA;EACC,0BAA0B;EAC1B,MAAM;CACP;;CAEA;EACC,kBAAkB;CACnB;;CAEA;EACC,eAAe;CAChB;;CAEA;;;EAGC,eAAe;CAChB;;CAEA;EACC,eAAe;CAChB;;CAEA;EACC,eAAe;CAChB;;CAEA;;EAEC,kBAAkB;EAClB,mBAAmB;CACpB;;CAEA;EACC,wBAAwB;EACxB,kBAAkB;CACnB;;CAEA;EACC,WAAW;CACZ;;CAEA;;EAEC,WAAW;CACZ;;CAEA;EACC,gBAAgB;CACjB;;CAEA;EACC,0BAA0B;EAC1B,MAAM;CACP;;CAEA;EACC,iBAAiB;CAClB;;CAEA;EACC,eAAe;EACf,eAAe;EACf,iBAAiB;CAClB;;CAEA;EACC,mBAAmB;CACpB;;CAEA;EACC,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;CAChB;;CAEA;EACC,WAAW;EACX,SAAS;CACV;;CAEA;EACC,SAAS;CACV;;CAEA;EACC,0BAA0B;EAC1B,MAAM;EACN,mBAAmB;CACpB;;CAEA;EACC,6BAA6B;EAC7B,oBAAoB;CACrB;;CAEA;EACC,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,qBAAqB;CACtB;;CAEA;EACC,mBAAmB;EACnB,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,eAAe;CAChB;;CAEA;EACC,cAAc;EACd,WAAW;EACX,gBAAgB;CACjB;;CAEA;EACC,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;CAClB;;CAEA;EACC,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;EAC7B,eAAe;CAChB;AACD;;AAEA;CACC;EACC,eAAe;CAChB;;CAEA;;EAEC,UAAU;EACV,iBAAiB;EACjB,kBAAkB;CACnB;AACD","sourcesContent":[".contact-section,\n.site-footer {\n\tbox-sizing: border-box;\n\tmax-width: 1040px;\n\tmargin: 0 auto;\n\tpadding-left: 36px;\n\tpadding-right: 36px;\n\tcolor: #332e2b;\n\tfont-family: \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n}\n\n.contact-section {\n\tposition: relative;\n\tpadding-top: 68px;\n\tpadding-bottom: 116px;\n}\n\n.section-label {\n\tposition: absolute;\n\ttop: 74px;\n\tright: 36px;\n\tcolor: #6b8fc3;\n\tfont-size: 13px;\n\tletter-spacing: 1.5px;\n\ttext-transform: uppercase;\n}\n\n.contact-heading h2 {\n\tmargin: 0;\n\tfont-size: clamp(38px, 5vw, 52px);\n\tfont-weight: 400;\n\tletter-spacing: -1.5px;\n\tline-height: 1;\n}\n\n.contact-rule,\n.footer-rule {\n\theight: 1px;\n\tbackground: #4a4542;\n}\n\n.contact-rule {\n\tmargin-top: 17px;\n}\n\n.contact-copy {\n\twidth: 38%;\n\tpadding-top: 39px;\n\tcolor: #989492;\n\tfont-size: 14px;\n\tline-height: 1.55;\n}\n\n.contact-intro {\n\tmargin: 0 0 28px;\n\tcolor: #414756;\n\tfont-size: 14px;\n\tline-height: 1.55;\n}\n\n.contact-intro a {\n\tcolor: #6b8fc3;\n\ttext-decoration: none;\n}\n\n.contact-body {\n\tdisplay: block;\n\tpadding: 0 36px;\n}\n\n.contact-copy p {\n\tmargin: 0 0 18px;\n}\n\n#contact .section-title h2::before {\n\tdisplay: none;\n\tcontent: none;\n}\n\n.contact-icon {\n\tdisplay: none;\n}\n\n.contact-envelope {\n\tdisplay: block;\n\tfont-size: 56px;\n\tline-height: 1;\n}\n\n.contact-envelope::before {\n\tcontent: \"\\f0e0\";\n}\n\n.contact-email,\n.footer-email {\n\tcolor: #4b4643;\n\tfont-weight: 600;\n\ttext-decoration: none;\n}\n\n.footer-email:hover,\n.footer-email:focus {\n\tcolor: #b9a7dc;\n}\n\n.contact-form {\n\twidth: 61%;\n\tmargin: -106px 0 0 auto;\n}\n\n.contact-form label {\n\tdisplay: block;\n\tmargin-bottom: 14px;\n\tcolor: #6b8fc3;\n\tfont-size: 11px;\n\tletter-spacing: 1.3px;\n\ttext-transform: uppercase;\n}\n\n.contact-field-row {\n\tdisplay: grid;\n\tgrid-template-columns: 1fr 1fr;\n\tgap: 14px;\n}\n\n.contact-form input,\n.contact-form textarea {\n\tbox-sizing: border-box;\n\tdisplay: block;\n\twidth: 100%;\n\tmargin-top: 6px;\n\tborder: 1px solid #dedbd9;\n\tborder-radius: 4px;\n\tpadding: 13px 15px;\n\tcolor: #332e2b;\n\tbackground: #fff;\n\tfont: inherit;\n\tfont-size: 14px;\n\toutline: none;\n}\n\n.contact-form input {\n\theight: 43px;\n}\n\n.contact-form textarea {\n\tmin-height: 117px;\n\tresize: vertical;\n}\n\n.contact-form input:focus,\n.contact-form textarea:focus {\n\tborder-color: #6b8fc3;\n}\n\n.contact-form input::placeholder,\n.contact-form textarea::placeholder {\n\tcolor: #c3bfbd;\n}\n\n.contact-form button {\n\tmargin-top: 1px;\n\tborder: 1px solid #6b8fc3;\n\tborder-radius: 0;\n\tpadding: 11px 22px;\n\tcolor: #5d5855;\n\tbackground: #fff;\n\tfont: inherit;\n\tfont-size: 13px;\n\tfont-weight: 600;\n\tcursor: pointer;\n}\n\n.contact-form button:hover:not(:disabled) {\n\tcolor: #fff;\n\tbackground: #6b8fc3;\n}\n\n.contact-form button:disabled {\n\tcursor: wait;\n\topacity: .6;\n}\n\n.form-status {\n\tmargin: 12px 0 0;\n\tcolor: #6b8fc3;\n\tfont-size: 13px;\n}\n\n.form-status-error {\n\tcolor: #a45757;\n}\n\n.site-footer {\n\tpadding-bottom: 23px;\n}\n\n.site-footer .footer-rule {\n\twidth: calc(100% + 72px);\n\tmargin-left: -36px;\n}\n\n.footer-content {\n\tposition: relative;\n\tmin-height: 174px;\n\tpadding-top: 29px;\n}\n\n.footer-statement {\n\tmax-width: 700px;\n\tfont-size: clamp(30px, 3.2vw, 38px);\n\tfont-weight: 400;\n\tletter-spacing: -0.5px;\n\tline-height: 1.2;\n}\n\n.footer-line {\n\tdisplay: block;\n\twhite-space: nowrap;\n}\n\n.footer-accent {\n\tcolor: #5f83b9;\n}\n\n.footer-meta {\n\tposition: absolute;\n\tright: 0;\n\tbottom: 26px;\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: flex-start;\n\tgap: 13px;\n\tfont-size: 13px;\n}\n\n.footer-links {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\twidth: 100%;\n\tgap: 20px;\n}\n\n.footer-links a {\n\tcolor: #4b4643;\n\ttext-decoration: none;\n}\n\n.footer-links a:hover,\n.footer-links a:focus {\n\tcolor: #b9a7dc;\n}\n\n.footer-links li {\n\tlist-style: none;\n}\n\n.footer-links li a {\n\tfont-size: 0;\n}\n\n.footer-links li a::after {\n\tfont-size: 13px;\n}\n\n.footer-links li:nth-child(1) a::after { content: \"LinkedIn\"; }\n.footer-links li:nth-child(2) a::after { content: \"GitHub\"; }\n\n.footer-copyright {\n\tposition: absolute;\n\tbottom: 0;\n\tleft: 50%;\n\tcolor: #aaa5a2;\n\tfont-size: 10px;\n\tletter-spacing: 2px;\n\ttext-transform: uppercase;\n\ttransform: translateX(-50%);\n\twhite-space: nowrap;\n}\n\n.portfolio-page {\n\twidth: min(1040px, calc(100% - 60px));\n}\n\n.section-title h2 {\n\tfont-size: 30px;\n}\n\n.resume-section .section-title h2,\n#education.section-title h2,\n#contact .section-title h2 {\n\tfont-size: 30px;\n}\n\n#resume .section-title h2 {\n\tfont-size: 30px;\n}\n\n.site-header {\n\tposition: sticky;\n\ttop: 0;\n\tz-index: 100;\n\tbackground: #fff;\n\tbox-shadow: 0 1px 0 rgba(63, 57, 52, .12);\n}\n\n.nav-links a.active {\n\tcolor: #6b8fc3;\n\tfont-weight: 600;\n}\n\n.back-to-top {\n\tposition: fixed;\n\tright: 24px;\n\tbottom: 24px;\n\tdisplay: grid;\n\tplace-items: center;\n\twidth: 40px;\n\theight: 40px;\n\tborder: 1px solid #6b8fc3;\n\tborder-radius: 50%;\n\tcolor: #6b8fc3;\n\tbackground: #fff;\n\tbox-shadow: 0 2px 8px rgba(63, 57, 52, .12);\n\tfont-size: 14px;\n\ttext-decoration: none;\n}\n\n.back-to-top:hover,\n.back-to-top:focus {\n\tcolor: #fff;\n\tbackground: #6b8fc3;\n}\n\n#about,\n#resume,\n#education,\n#contact {\n\tscroll-margin-top: 84px;\n}\n\n.brand span {\n\tdisplay: inline-grid;\n\tplace-items: center;\n\twidth: 30px;\n\theight: 30px;\n\tborder-radius: 5px;\n\tmargin-right: 9px;\n\tpadding: 0;\n\tfont-size: 13px;\n\tline-height: 1;\n\ttext-align: center;\n\tvertical-align: middle;\n}\n\n.resume-link {\n\tpadding-top: 5px;\n\tpadding-bottom: 5px;\n}\n\n.site-header a.resume-link:hover,\n.site-header a.resume-link:focus,\n.site-header a.resume-link:active {\n\tborder-color: #6b8fc3;\n\tcolor: #fff !important;\n\tbackground: #6b8fc3;\n}\n\n.skill-group span {\n\tpadding-top: 2px;\n\tpadding-bottom: 2px;\n}\n\n.education-strip {\n\tdisplay: block;\n\twidth: 100%;\n\tborder-top: 0;\n}\n\n.education-item {\n\twidth: 100%;\n}\n\n.monogram {\n\tdisplay: block;\n\twidth: 100%;\n\theight: auto;\n\tobject-fit: cover;\n}\n\n.hero-section {\n\talign-items: center;\n}\n\n.profile-summary {\n\talign-self: center;\n\tmargin-top: 0;\n}\n\n.summary-meta strong {\n\tfont-size: 11px;\n}\n\n@media (min-width: 721px) {\n\t.resume-section .section-title h2,\n\t#education.section-title h2,\n\t#contact .section-title h2 {\n\t\tfont-size: 30px;\n\t}\n\n\t#resume h3 {\n\t\tfont-size: 25px;\n\t}\n}\n\n#contact.contact-section {\n\tdisplay: block;\n\twidth: 100%;\n\tmax-width: none;\n\tpadding: 0 0 116px;\n\tborder-top: 0;\n\tcolor: #332e2b;\n}\n\n#contact .section-title {\n\tdisplay: flex;\n\tjustify-content: space-between;\n\talign-items: baseline;\n\tmargin: 0 0 20px;\n\tpadding-bottom: 10px;\n\tborder-bottom: 1px solid #3f3934;\n}\n\n#contact .section-title h2 {\n\tcolor: #332e2b;\n\tletter-spacing: 1px;\n}\n\n#contact .section-title span {\n\tcolor: #6b8fc3;\n\tfont-size: 10px;\n\tletter-spacing: 1.5px;\n\ttext-transform: uppercase;\n}\n\n#contact .contact-heading h2 {\n\tmargin: 0;\n\tcolor: #332e2b;\n\tfont-size: clamp(38px, 5vw, 52px);\n\tfont-weight: 400;\n\tletter-spacing: -1.5px;\n\tline-height: 1;\n\ttext-transform: none;\n}\n\n#contact .contact-copy {\n\tdisplay: block;\n\twidth: 100%;\n\tmargin: 0;\n\tpadding-top: 0;\n}\n\n#contact .contact-icon {\n\tpadding-top: 0;\n}\n\n#contact .contact-intro {\n\tmargin: 0 0 28px;\n\tcolor: #414756;\n\tfont-size: 14px;\n\tline-height: 1.55;\n}\n\n#contact .contact-body {\n\tdisplay: block;\n\tpadding: 0 60px;\n}\n\n#contact .contact-copy p {\n\tmargin: 0 0 18px;\n\tcolor: #414756;\n\tfont-size: 14px;\n\tline-height: 1.55;\n}\n\n#contact .contact-copy a {\n\tcolor: #6b8fc3;\n\ttext-decoration: none;\n}\n\n#contact a,\n#contact a:visited {\n\tcolor: #525252;\n\tfont-weight: 600;\n}\n\n#contact a:focus,\n#contact a:hover {\n\tcolor: #b9a7dc;\n}\n\n#contact .contact-form {\n\tdisplay: block;\n\twidth: 100%;\n\tmargin: 0;\n}\n\n#contact .contact-form label {\n\tdisplay: block;\n\twidth: auto;\n\tmargin: 0 0 14px;\n\tfloat: none;\n\tcolor: #6b8fc3;\n\tfont: 11px/1.2 \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n\tfont-weight: 400;\n\tletter-spacing: 1.3px;\n\ttext-transform: uppercase;\n}\n\n#contact .contact-field-row {\n\tdisplay: grid;\n\tgrid-template-columns: 1fr 1fr;\n\tgap: 14px;\n}\n\n#contact .contact-form input,\n#contact .contact-form textarea {\n\tbox-sizing: border-box;\n\tdisplay: block;\n\twidth: 100%;\n\tmin-width: 0;\n\tmax-width: none;\n\tmargin: 6px 0 0;\n\tborder: 1px solid #dedbd9;\n\tborder-radius: 4px;\n\tpadding: 13px 15px;\n\tcolor: #332e2b;\n\tbackground: #fff;\n\tfont: 14px/1.45 \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n\toutline: none;\n}\n\n#contact .contact-form input {\n\theight: 43px;\n}\n\n#contact .contact-form textarea {\n\tmin-height: 117px;\n\tresize: vertical;\n}\n\n#contact .contact-form button {\n\tdisplay: inline-block;\n\tmargin: 1px 0 0;\n\tborder: 1px solid #6b8fc3;\n\tborder-radius: 4px;\n\tpadding: 11px 22px;\n\tcolor: #5d5855;\n\tbackground: #fff;\n\tfont: 600 13px/1.2 \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n\tletter-spacing: 0;\n\ttext-transform: none;\n}\n\n#contact .contact-form button:hover:not(:disabled) {\n\tcolor: #fff;\n\tbackground: #6b8fc3;\n}\n\n@media (max-width: 800px) {\n\t.education-strip {\n\t\tgrid-template-columns: 1fr;\n\t\tgap: 25px;\n\t}\n\n\t.site-footer {\n\t\tpadding-left: 22px;\n\t\tpadding-right: 22px;\n\t}\n\n\t.site-footer .footer-rule {\n\t\twidth: calc(100% + 44px);\n\t\tmargin-left: -22px;\n\t}\n\n\t.footer-content {\n\t\tmin-height: 238px;\n\t}\n\n\t.footer-statement {\n\t\tmax-width: none;\n\t\tfont-size: 24px;\n\t\tline-height: 1.25;\n\t}\n\n\t.footer-line {\n\t\twhite-space: normal;\n\t}\n\n\t.footer-meta {\n\t\tposition: static;\n\t\talign-items: center;\n\t\tmargin-top: 28px;\n\t\tfont-size: 14px;\n\t}\n\n\t.footer-links {\n\t\twidth: auto;\n\t\tgap: 20px;\n\t}\n\n\t.footer-copyright {\n\t\tbottom: 0;\n\t}\n}\n\n@media (min-width: 721px) and (max-width: 800px) {\n\t.skill-grid {\n\t\tgrid-template-columns: repeat(2, 1fr);\n\t\tgap: 24px;\n\t\tmargin: 45px 0 60px;\n\t}\n}\n\n@media (max-width: 500px) {\n\t.portfolio-page {\n\t\twidth: calc(100% - 76px);\n\t}\n}\n\n@media (max-width: 720px) {\n\t.portfolio-page {\n\t\twidth: calc(100% - 32px);\n\t}\n\n\t#contact.contact-section {\n\t\tpadding: 0 0 80px;\n\t}\n\n\t#contact .contact-copy,\n\t#contact .contact-form {\n\t\twidth: 100%;\n\t}\n\n\t#contact .contact-form {\n\t\tmargin: 0;\n\t}\n\n\t#contact .contact-body {\n\t\tpadding: 0 30px;\n\t}\n\n\t#contact .contact-form {\n\t\tmargin-top: 42px;\n\t}\n\n\t#contact .contact-field-row {\n\t\tgrid-template-columns: 1fr;\n\t\tgap: 0;\n\t}\n\n\t.hero-section {\n\t\talign-items: start;\n\t}\n\n\t.section-title h2 {\n\t\tfont-size: 25px;\n\t}\n\n\t.resume-section .section-title h2,\n\t#education.section-title h2,\n\t#contact .section-title h2 {\n\t\tfont-size: 25px;\n\t}\n\n\t#resume .section-title h2 {\n\t\tfont-size: 25px;\n\t}\n\n\t#resume h3 {\n\t\tfont-size: 20px;\n\t}\n\n\t.contact-section,\n\t.site-footer {\n\t\tpadding-left: 22px;\n\t\tpadding-right: 22px;\n\t}\n\n\t.site-footer .footer-rule {\n\t\twidth: calc(100% + 44px);\n\t\tmargin-left: -22px;\n\t}\n\n\t.section-label {\n\t\tright: 22px;\n\t}\n\n\t.contact-copy,\n\t.contact-form {\n\t\twidth: 100%;\n\t}\n\n\t.contact-form {\n\t\tmargin-top: 42px;\n\t}\n\n\t.contact-field-row {\n\t\tgrid-template-columns: 1fr;\n\t\tgap: 0;\n\t}\n\n\t.footer-content {\n\t\tmin-height: 238px;\n\t}\n\n\t.footer-statement {\n\t\tmax-width: none;\n\t\tfont-size: 24px;\n\t\tline-height: 1.25;\n\t}\n\n\t.footer-line {\n\t\twhite-space: normal;\n\t}\n\n\t.footer-meta {\n\t\tposition: static;\n\t\talign-items: center;\n\t\tmargin-top: 28px;\n\t\tfont-size: 14px;\n\t}\n\n\t.footer-links {\n\t\twidth: auto;\n\t\tgap: 20px;\n\t}\n\n\t.footer-copyright {\n\t\tbottom: 0;\n\t}\n\n\t.skill-grid {\n\t\tgrid-template-columns: 1fr;\n\t\tgap: 0;\n\t\tmargin: 42px 0 58px;\n\t}\n\n\t.skill-group {\n\t\tborder-top: 2px solid #3f3934;\n\t\tpadding: 17px 0 24px;\n\t}\n\n\t.skill-group h3 {\n\t\tmargin-bottom: 14px;\n\t\tcolor: #866aa0;\n\t\tfont-size: 14px;\n\t\tletter-spacing: 1.5px;\n\t}\n\n\t.skill-group span {\n\t\tmargin: 0 5px 8px 0;\n\t\tpadding: 8px 14px;\n\t\tborder: 1px solid #b7c7e5;\n\t\tborder-radius: 16px;\n\t\tcolor: #525252;\n\t\tfont-size: 14px;\n\t}\n\n\t.profile-summary {\n\t\tdisplay: block;\n\t\twidth: 100%;\n\t\tmargin-top: 24px;\n\t}\n\n\t.profile-summary .monogram {\n\t\twidth: 100%;\n\t\taspect-ratio: 0.8;\n\t\tborder-radius: 4px;\n\t\tobject-fit: cover;\n\t}\n\n\t.profile-summary .summary-meta {\n\t\tdisplay: flex;\n\t\tjustify-content: space-between;\n\t\talign-items: center;\n\t\tgap: 16px;\n\t\tmargin-top: 20px;\n\t\tpadding-top: 17px;\n\t\tborder-top: 1px solid #3f3934;\n\t\tfont-size: 14px;\n\t}\n}\n\n@media (min-width: 501px) and (max-width: 720px) {\n\t.profile-summary {\n\t\tpadding: 0 12px;\n\t}\n\n\t.profile-summary .monogram,\n\t.profile-summary .summary-meta {\n\t\twidth: 60%;\n\t\tmargin-left: auto;\n\t\tmargin-right: auto;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
